import script from "./ContactDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactDialog.vue?vue&type=script&setup=true&lang=js"

import "./ContactDialog.vue?vue&type=style&index=0&id=1d41219a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d41219a"]])

export default __exports__